import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

export interface Favorites {
  instructorIds: string[];
  aircraftIds: string[];
  selfOnlyInstructor?: boolean;
}

@Injectable({ providedIn: "root" })
export class FavoritesService {
  constructor(private http: HttpClient) {}

  getFavorites(): Observable<Favorites> {
    return this.http.get<Favorites>("/api/me/favorites");
  }

  updateFavorites(fav: Favorites): Observable<void> {
    return this.http.put<void>("/api/me/favorites", fav);
  }
}
